import GlobalContext from '../bootstrap';
import resetableField from '../forms/resetable-field';
import initPagination from '../pagination';
import openSearchFilters from '../property/search-popup';
import initResumeUploadForm from '../resume/upload';
import initMobileFilters from '../search/mobile-filters';
import initTypeaheads from '../typeahead';

class JobsPage extends GlobalContext {
    constructor() {
        super();
        this._initialiseComponents();
    }

    _initialiseComponents(): void {
        initResumeUploadForm();

        resetableField();

        initTypeaheads();

        const form = document.querySelector<HTMLFormElement>( '.jobs__search-form' );

        if ( form ) {
            initMobileFilters( form );

            const orderBy = document.querySelector<HTMLSelectElement>( '#search-orderby' );
            const orderByInput = form.querySelector<HTMLInputElement>( '[name="order"]' );

            if ( orderBy && orderByInput ) {
                orderBy.addEventListener( 'change', function( event: Event ) {
                    event.preventDefault();
                    orderByInput.value = orderBy.value;
                    form.submit();
                } );
            }

            const autoTriggerSubmitSelects = form.querySelectorAll( '[name=sector],[name=radius],[name=order]' );

            for ( let i = 0; i < autoTriggerSubmitSelects.length; i++ ) {
                autoTriggerSubmitSelects[ i ].addEventListener( 'change', function() {
                    form.submit();
                } );
            }
        }

        document.querySelectorAll<HTMLButtonElement>( 'button[data-action="open-search-filters"]' ).forEach( ( btn: HTMLButtonElement ) => {
            btn.addEventListener( 'click', () => {
                window.router.CaptureThen( openSearchFilters );
            } );

            btn.dataset.initialised = 'true';
        } );

        if ( document.body.classList.contains( 'twc__pagination' ) ) {
            initPagination( document.body );
        }
    }
}

if ( !window.jobsPage ) {
    window.jobsPage = new JobsPage();
}
